/* jshint esversion: 6 */

import React, {
  Fragment,
} from 'react';
import PropTypes from 'prop-types';
import UserRoleContainer from './UserRoleContainer'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  withRouter
} from "react-router-dom";
class ListRoles extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      role: [],
    };
  }
  componentDidMount() {
    const headers = {
      'Accept': 'application/json'
    }
    fetch(this.props.action, { headers })
    .then(res => res.json())
    .then(data => {
      this.setState({
        role: data,
        loaded: true
      })
    })
  }
  componentWillUnmount() {
    // clear the canvas
    this.setState({
      loaded: false,
      role: []
    })
  }
  render() {
    let loaded = this.state.loaded
    let userRoles = this.state.role
    return (
      <div>
        <div className='heading'>
          <a href={this.props.backAction} className="back-btn"></a>
          <h3>User Roles</h3>
          <div className="spacer"></div>
          <Link to="/new" className="button-send">Create Role</Link>
        </div>
        {loaded &&
        <div className="section">
          {userRoles.map((role) =>
            <UserRoleContainer role={role} action={this.props.action} authenticityToken={this.props.authenticityToken} />
          )}
        </div>
        }
      </div>
    )
  }
}
ListRoles.propTypes = {
  role: PropTypes.array,
  action: PropTypes.string,
  authenticityToken: PropTypes.string,
};
export default withRouter(ListRoles)
